import { create } from "zustand";
import { persist } from "zustand/middleware";
import { produce } from "immer";
import CryptoJS from 'crypto-js';
import { initRecommend, Recommend, RecommendState } from "./initialState";
import { createEncryptedStorage } from "@/lib/encryptedStorage";

const hashCode = process.env.NEXT_PUBLIC_HASH_CODE;
if (!hashCode) {
  throw new Error("NEXT_PUBLIC_HASH_CODE environment variable is not set");
}

// 定義儲存的資料格式
interface StoredState {
  recommend: Recommend;
}

// 判斷是否為舊格式的資料
const isLegacyData = (data: any): boolean => {
  if (!data || typeof data !== 'string') {
    return false;
  }

  try {
    const parsedData = JSON.parse(data);
    const isLegacy = (
      typeof parsedData === 'object' &&
      parsedData !== null &&
      'state' in parsedData &&
      typeof parsedData.state === 'object' &&
      'recommend' in parsedData.state &&
      typeof parsedData.state.recommend === 'string'
    );

    return isLegacy;
  } catch (error) {
    return false;
  }
};

// 轉換舊格式的資料
const migrateLegacyData = (data: any): StoredState => {
  try {
    const parsedData = JSON.parse(data);
    if (parsedData && parsedData.state && typeof parsedData.state.recommend === 'string') {
      try {
        const decrypted = CryptoJS.AES.decrypt(parsedData.state.recommend, hashCode).toString(CryptoJS.enc.Utf8);
        const recommend = JSON.parse(decrypted);
        if (recommend && typeof recommend === 'object') {
          return { recommend };
        }
      } catch (decryptError) {

      }
    }
  } catch (error) {

  }
  return { recommend: initRecommend };
};

export const useRecommendStore = create<RecommendState>()(
  persist(
    (set, get) => ({
      // 初始化時使用預設值
      recommend: initRecommend,

      // 更新函式直接處理解密後的資料
      updateRecommend: (recommend: Recommend) => {
        set(
          produce((draft) => {
            draft.recommend = recommend;
          })
        );
      },

      // 取得函式直接回傳記憶體中的資料
      getRecommend: () => {
        return get().recommend;
      },
    }), {
      name: "recommend",
      storage: createEncryptedStorage<StoredState>({
        isLegacyData,
        migrateLegacyData
      }),
      partialize: (state) => ({ recommend: state.recommend }),
    }
  )
);
